import React, { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import WagesData from '../data/WagesData';
import FixedLayout from '../components/FixedLayout';
import { CountrySectionData } from '../data/sections/ConuntrySectionData';

const Country = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Reset scroll position to top when page loads
      }, []);
    const navigate = useNavigate();
    const { item  } = useParams();
    const { state: country } = useLocation();
    const fetchedCountry = country || WagesData.wagesdata.find((dataItem) =>
        dataItem.title.replace(/\s+/g, '-').toLowerCase() === decodeURIComponent(item).replace(/\s+/g, '-').toLowerCase()
      );
      console.log('Item from URL:', item);
      console.log("Country data from state:", country);
      console.log('Fetched Country:', fetchedCountry);

      if (!fetchedCountry) {
        return <p>Country not found or data not available.</p>;
      }
    
      const fetchedCountryDetail =
        country
          ? CountrySectionData.countries.find((c) => 
              c.country.replace(/\s+/g, '-').toLowerCase() ===decodeURIComponent(item).replace(/\s+/g, '-').toLowerCase())
          : null;
      
      if (!fetchedCountryDetail) {
        return <p>Country not found or data not available.</p>;
      }

    
  return (
   <>
   {/* Start Banner */}
   <div className="wrapper cguide-section" style={{ backgroundImage: `url(${fetchedCountry?.imageUrl})` }}>
    <div className="container">
            <div className="guide-card">
                <div className="guide-header">
                    <button className="back-link" onClick={() => navigate(-1)}> &#8592;   Back</button>
                   {/*  <button className="cal-link" onClick={() => navigate('cost-calculator')} > Cost Calculator  &#8594;</button> */}
                </div>
                
                <h1 className="guide-title">Payroll and Benefits Guide</h1>
                <h2 className="guide-country">{fetchedCountry.title}</h2>
                <div className="guide-details">
                    <div className="detail">
                    <strong>Currency</strong>
                    <p>{fetchedCountry.currency}</p>
                    </div>
                    <div className="detail">
                    <strong>Payroll Frequency</strong>
                    <p>Monthly</p>
                    </div>
                    <div className="detail">
                    <strong>Capital</strong>
                    <p>Buenos Aires</p>
                    </div>
                    <div className="detail">
                    <strong>Fiscal Year</strong>
                    <p>1 January - 31 December</p>
                    </div>
                    <div className="detail">
                    <strong>Employer Taxes</strong>
                    <p>{fetchedCountryDetail.employer_contributions.total_employer_contribution.rate}</p>
                    </div>
                    <div className="detail">
                    <strong>Employee Costs</strong>
                    <p>{fetchedCountryDetail.employee_contributions.total_employee_contribution.rate}</p>
                    </div>
                    <div className="detail">
                    <strong>Date Format</strong>
                    <p>dd/mm/yyyy</p>
                    </div>
                </div>

                <div className="guide-footer">
                
                </div>
            </div>
    </div>
   </div>
   {/* End Banner */}
    <FixedLayout country={fetchedCountry.title} />
   </>
  )
}

export default Country